<template>
    <div class="signinwith">
        <memberCentreNav></memberCentreNav>
        <div class="writing_right">
            <div class="TitleList">
                <div class="TitleList_padding">
                    <div class="TitleList_top">
                        <div class="TitleList_top_title"><span></span>第三方登录</div>
                    </div>
                </div>
                <div class="signinwith_content">
                    <div class="signinwith_content_list">
                        <div class="content_list_icon">
                            <div class="list_icon_left"><img src="@a/img/sv14.svg" /></div>
                            <div class="list_icon_right">支付宝</div>
                        </div>
                        <div class="content_list_right">
                            <div class="list_right_dd">绑定后可用于支付宝扫码登录</div>
                            <!-- <div class="list_right_dt">
                                <button>未绑定</button>
                            </div> -->
                        </div>
                    </div>
                    <div class="signinwith_content_list">
                        <div class="content_list_icon">
                            <div class="list_icon_left"><img src="@a/img/sv15.svg" /></div>
                            <div class="list_icon_right">QQ</div>
                        </div>
                        <div class="content_list_right">
                            <div class="list_right_dd">绑定后可用于支QQ扫码登录</div>
                            <!-- <div class="list_right_dt">已绑定</div> -->
                        </div>
                    </div>
                    <div class="signinwith_content_list">
                        <div class="content_list_icon">
                            <div class="list_icon_left"><img src="@a/img/sv16.svg" /></div>
                            <div class="list_icon_right">微信</div>
                        </div>
                        <div class="content_list_right">
                            <div class="list_right_dd">绑定后可用于微信扫码登录</div>
                            <!-- <div class="list_right_dt">已绑定</div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import memberCentreNav from "@c/common/memberCentreNav/memberCentreNav";

    export default {
        name: "basicinformation",
        data() {
            return {
                
            };
        },
        components: {
            memberCentreNav
        },
        methods:{
          
        },
        mounted() {
            
        },
    }
</script>

<style>
  @import "signInWith.css";
</style>